// extracted by mini-css-extract-plugin
export default {"confirm":"ConfirmAction_confirm__74aZ3","confirm__btn":"ConfirmAction_confirm__btn__SGNQn"};